import React from 'react';
import { FieldThumbnail } from '@tcc/crate';
import { toDateString } from '../../../utils/date';
import { categoryTypeColor } from '../../../utils/scoutingUtils';

import { GeoJson, EnhancedActivity, Activity, isEnhancedActivity } from '../../../types';

import styles from './EnhancedScoutingPin.css';

export type EnhancedScoutingPinCardProps = {
  activity: Activity | EnhancedActivity;
  geoJson: GeoJson;
  locale: string;
  onPinClick: () => void
}

export const EnhancedScoutingPin = ({ activity, locale, geoJson, onPinClick }: EnhancedScoutingPinCardProps) => {
  const { id, color, title, scoutedAt } = activity

  const enhancedColor = isEnhancedActivity(activity) ? categoryTypeColor(activity.categoryType) : color;

  return (
    <div
      className={styles.activityRow}
      data-test-id={`activity-row-${id}`}
      onClick={onPinClick}
      role="button"
      tabIndex={0}
    >
      <div
        className={styles.activityIcon}
        data-test-id="activity-icon"
        style={{ color: enhancedColor }}
      >
        <FieldThumbnail
          geoJson={geoJson}
          fillColor="#FFF"
          regionFillOpacity={0.2}
          pinColor={enhancedColor} 
          pinRadius={5}
        />
      </div>
      <div className={styles.activityContent}>
        <div
          className={styles.activityTitle}
          data-test-id="activity-title"
        >
          {title || '-'}
        </div>
        <time
          className={styles.activityScoutedAt}
          data-test-id="activity-scoutedAt"
        >
          {toDateString(scoutedAt, locale)}
        </time>
      </div>
    </div>
  );
}
